export const generalKey = 'product_fridge_RF403';
export const whiteLocaleList = ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'jp']; //白名单
export const productPageUrl = 'glacier-classic-portable-refrigerator';
export const tabsValues = ['Product', 'Bundles'];
export const productPageTheme = 'white'; //主题色
